<template>
  <div>
    <pdf
      v-for="i in page_count"
      :src="computedSourcePath"
      :page="i"
      style="display: inline-block; width: 100%"
      :key="i"
    />
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components: { pdf },
  props: {
    src: String
  },
  computed: {
    computedSourcePath() {
      return pdf.createLoadingTask(`${process.env.VUE_APP_SERVER_URL}/${this.src}`)
    }
  },
  data() {
    return {
      page_count: null,
      pdfs: []
    }
  },
  mounted() {
    let numPages = undefined
    // let arr = []
    this.computedSourcePath.promise.then(pdf => {
      numPages = pdf._pdfInfo.numPages; 
      // let result = {
      //   numPages,
      //   src: this.computedSourcePath
      // }
      this.page_count = numPages
      // console.log('result',result)
      // this.pdfs.push(result)
    })
    // this.page_count = arr
    // console.log(' this.page_count', this.pdfs)
  }
}
</script>